/*=======================================================================
 * $Id: app.js 82512 2020-06-15 17:22:07Z sabri.nuzi $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2020
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["underscore", "jquery"], function(_, $) {
  function WindowUtility(options) {
    this.options = options;
  }

  _.extend(WindowUtility.prototype, {
    calcOffset: function(elem, offsetParent) {
      if (!elem) {
        return 0;
      }
      if (offsetParent) {
        if (elem.parentElement === offsetParent) {
          return 0;
        }
      } else {
        if (!elem.parentElement) {
          return 0;
        }
      }
      try {
        var paddingMargin = this.calcPaddingAndMargin(elem);
        var sum = this.calcOffset(elem.parentElement, offsetParent) + paddingMargin;
        return sum;
      } catch (e) {
        return 0;
      }
    },

    calcSiblingsHeight: function(elem, offsetParent) {
      if (!elem || elem === offsetParent) {
        return 0;
      }
      var height = 0;
      var targetTop = elem.offsetTop;
      var sibling = elem.previousElementSibling;
      while (sibling) {
        if (sibling.offsetTop + sibling.offsetHeight <= targetTop) {
          height += this.calcPaddingAndMargin(sibling) + sibling.offsetHeight;
        }
        sibling = sibling.previousElementSibling;
      }
      var sum = height + this.calcSiblingsHeight(elem.parentElement, offsetParent);
      return sum;
    },

    calcPaddingAndMargin: function(elem) {
      var computed = window.getComputedStyle(elem);
      var paddingMargin = Math.ceil(
        (parseFloat(computed.paddingTop) || 0) +
          (parseFloat(computed.paddingBottom) || 0) +
          (parseFloat(computed.marginTop) || 0) +
          (parseFloat(computed.marginBottom) || 0)
      );

      return paddingMargin;
    },

    resizeToBottom: function() {
      var height;

      if (this.options && this.options.height) {
        height = this.options.height;
      }

      if (height && height !== "auto") {
        return;
      }
      if (this.options.el) {
        this._calcHeight();
      }
    },

    sanitizeHeightValue: function(newHeight) {
      if (typeof newHeight !== "string") return null;
      newHeight = newHeight.trim();

      const regex = /^([0-9]+)(px|vh|%|em|rem)$/;
      const match = regex.exec(newHeight);

      if (match && match.length === 3) {
        const number = parseInt(match[1], 10);

        const unit = match[2];
        if ((unit === "%" && number >= 0 && number <= 100) || (unit !== "%" && number >= 0)) {
          return newHeight;
        }
      }

      return null;
    },

    _calcHeight: function() {
      try {
        var newTarget = this.options.el;
        var findSeconderyTarget = this.options.findSeconderyTarget;
        var calcOffestFrom = this.options.calcOffestFrom;
        var offsetCandidate;

        if (!newTarget) return;

        //  in case the function is provided using secondery target has preority
        if (typeof findSeconderyTarget === "function") {
          var candidate = findSeconderyTarget(this.options.el);
          if (candidate) {
            newTarget = candidate;
          }
        }
        // use specific element to calcOffset from
        if (typeof calcOffestFrom === "function") {
          var candidate = calcOffestFrom(this.options.el);
          if (candidate) {
            offsetCandidate = candidate;
          }
        }
        var viewportElement = this.options.viewportElement || document.documentElement;
        var offset = this.calcOffset(offsetCandidate || newTarget, viewportElement);
        var siblingsHeight = this.calcSiblingsHeight(offsetCandidate || newTarget, viewportElement);
        var newTargetPaddings = this.calcPaddingAndMargin(offsetCandidate || newTarget);
        var windowBasedHeight = window.innerHeight - offset - siblingsHeight;

        var computedStyle = window.getComputedStyle(viewportElement);
        var viewportHeight = Math.floor(parseFloat(computedStyle.height));
        var viewportBasedHeight = viewportHeight - offset - siblingsHeight;
        if (viewportBasedHeight >= 500 && viewportBasedHeight <= windowBasedHeight) {
          windowBasedHeight = viewportBasedHeight;
        }

        if (windowBasedHeight < 500) return;
        newTarget.style.height = windowBasedHeight - newTargetPaddings + "px";
        //FIXME - due to layout complexity of preview element we had to make sure the height remain in container element
        offsetCandidate && (offsetCandidate.style.height = parseFloat(newTarget.style.height) - offset + "px");
      } catch (err) {
        console.warn("Failed to calculate height!", err);
      }
    }
  });

  return WindowUtility;
});
